class IntLocalFormat extends HTMLInputElement {
  static get THOUSAND_SEPARATOR () {
    return new Intl.NumberFormat(navigator.language).format(999999).replace(/9/g, '')
  }

  connectedCallback () {
    this.pattern = this._pattern()
    this.addEventListener('input', () => {
      if (this.value !== '') {
        const valor = this.valueAsNumber
        const max = this.hasAttribute('max') ? parseInt(this.getAttribute('max')) : valor
        const min = this.hasAttribute('min') ? parseInt(this.getAttribute('min')) : valor

        if (isNaN(valor)) {
          this.setCustomValidity('Debe ser un número')
        } else if (valor > max) {
          this.setCustomValidity(`El valor debe ser inferior o igual a ${this._numberToLocalString(max)}`)
        } else if (valor < min) {
          this.setCustomValidity(`El valor debe ser superior o igual a ${this._numberToLocalString(min)}`)
        } else {
          this.setCustomValidity('')
        }

        this.value = isNaN(valor) ? '' : this._numberToLocalString(valor)
      }
    })
  }

  get valueAsNumber () {
    return Number(this.originalValue())
  }

  originalValue () {
    return this.value.replace(new RegExp(`[${IntLocalFormat.THOUSAND_SEPARATOR}]`, 'g'), '')
  }

  _pattern () {
    if (this._min() < 1000) {
      return `[0-9]{1,3}([${IntLocalFormat.THOUSAND_SEPARATOR}']?[0-9]{3}){0,}`
    } else {
      return `[0-9]{1,3}([${IntLocalFormat.THOUSAND_SEPARATOR}']?[0-9]{3}){1,}`
    }
  }

  _min () {
    const min = parseInt(this.getAttribute('min'))
    return isNaN(min) ? 0 : min
  }

  _numberToLocalString (number) {
    return new Intl.NumberFormat(navigator.language).format(number)
  }
}

export default IntLocalFormat
